import '../styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import { Selector } from 'components/SmartChatView/Fields'
import { Tooltip } from 'components/SmartChatView/Fields'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'

const RandomResponsesViewUI = ({ renderType, label, placeholder, randomResponsesOptions, value, onChangeInner, link, loadingRandomResponsesOptions, error, previewIntegrity }) => (
  <div className='action-view'>
    {renderType === 'action' && (
      <Selector
        isRequired
        label={label}
        placeholder={placeholder}
        options={randomResponsesOptions || []}
        value={value.randomResponses}
        onChange={onChangeInner}
        link={link}
        loading={loadingRandomResponsesOptions}
        error={error}
      />
    )}
    {renderType === 'preview' && (
      <div className='action-view__random-responses-preview'>
        {loadingRandomResponsesOptions ? (
          <Nixi1Spinner width='30px' height='30px' />
        ) : (
          <div className='action-view__random-responses-preview-container'>
            {value.randomResponses?.label && (
              <div className='action-view__random-responses-preview-content'>
                <p className='action-view__text'>{value.randomResponses.label}</p>
              </div>
            )}
            {value?.count >= 0 && (
              <div className='action-view__random-responses-preview-number-container'>
                <p className='action-view__random-responses-preview-text'>{I18n.t('smartchat_actions_label_randomMessagesCount')}:</p>
                <div className='action-view__random-responses-preview-number'>
                  <strong>{value.count}</strong>
                </div>
              </div>
            )}
          </div>
        )}
        {!loadingRandomResponsesOptions && previewIntegrity && (
          <Tooltip
            icon={getStaticImage('/icons/orange-brand/icon-warning-yellow.svg')}
            message={previewIntegrity}
          />
        )}
      </div>
    )}
  </div>
)

export default RandomResponsesViewUI
